"use client";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import {
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
  Typography,
} from "antd";
import SectionCard from "./SectionCard";
import { staticConfig } from "../../treasury.config";
import { Util } from "../helper/helper";
import React from "react";
const { Text, Link, Title, Paragraph } = Typography;

export function TaxAndCharges({
  setData,
  data,
  setActivePage,
  activePage,
  setHasModified,
  hasModifed,
  template,
}) {
  const [form, useWatch] = Form.useForm();

  const symbol = Util.getSymbol(template, data);

  const allowWithholdingTax = Form.useWatch("allowWithholdingTax", form);
  const setupCharges = Form.useWatch("setupCharges", form);
  const redemptionCharges = Form.useWatch("redemptionCharges", form);
  const transferCharges = Form.useWatch("transferCharges", form);
  const allowBrokerage = Form.useWatch("allowBrokerage", form);
  const allowTax = Form.useWatch("allowTax", form);

  const taxGroupOptions = template?.taxGroupOptions;

  const chargeOptions = template?.chargeOptions
    ?.filter(
      (option) =>
        option.active === true &&
        option.chargeAppliesTo?.toLowerCase() === "treasury"
    )
    .map((option) => ({
      value: option.value,
      label: option.label,
      chargeTimeType: option?.chargeTimeType,
    }));

  function goBack() {
    setActivePage(activePage - 1);
  }
  function onFinish(_data) {
    setData({ ...data, ..._data });
    setActivePage(activePage + 1);
  }
  function handleValuesChange() {
    setHasModified && setHasModified([...hasModifed, activePage]);
  }
  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data]);

  return (
    <SectionCard
      onPrev={goBack}
      onNext={form.submit}
      nextTitle={"Next - Accounting"}
    >
      <Title style={{ margin: 0, marginBottom: 5 }} level={3}>
        Tax & Charges
      </Title>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{ paddingTop: 0 }}
        onValuesChange={handleValuesChange}
      >
        {/* <Row>
          <Col
            span={6}
            style={{
              padding: "0px 8px",
              marginTop: 35,
              display: "flex",
              gap: 10,
            }}
          >
            {" "}
            <Form.Item
              name={"allowWithholdingTax"}
              style={{ margin: 0, padding: 0 }}
              valuePropName="checked"
            >
              <Switch className="custom-switch" />
            </Form.Item>
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
              Withholding Tax
            </Text>
          </Col>
          {allowWithholdingTax && (
            <Col span={6} style={{ padding: "0px 8px", marginTop: 28 }}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="withholdingTax"
                rules={[
                  {
                    required: true,
                    message: "Please select tax option",
                  },
                ]}
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-input"
                  // size="large"
                  options={withholdingTaxOptions}
                  placeholder={"Select tax option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row> */}
        <Row>
          <Col
            span={6}
            style={{
              padding: "0px 8px",
              marginTop: 35,
              display: "flex",
              gap: 10,
            }}
          >
            {" "}
            <Form.Item
              name={"allowTax"}
              style={{ margin: 0, padding: 0 }}
              valuePropName="checked"
            >
              <Switch className="custom-switch" />
            </Form.Item>
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
              Tax Group
            </Text>
          </Col>
          {allowTax && (
            <Col span={6} style={{ padding: "0px 8px", marginTop: 28 }}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="taxGroup"
                rules={[
                  {
                    required: true,
                    message: "Please select tax option",
                  },
                ]}
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-input"
                  virtual={false}
                  options={taxGroupOptions}
                  placeholder={"Select tax option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col
            span={6}
            style={{
              padding: "0px 8px",
              marginTop: 35,
              display: "flex",
              gap: 10,
            }}
          >
            {" "}
            <Form.Item
              name={"setupCharges"}
              style={{ margin: 0, padding: 0 }}
              valuePropName="checked"
            >
              <Switch className="custom-switch" />
            </Form.Item>
            {/* </Col> */}
            {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
              Setup Charges
            </Text>
          </Col>
          {setupCharges && (
            <Col span={6} style={{ padding: "0px 8px", marginTop: 28 }}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="setupCharge"
                rules={[
                  {
                    required: true,
                    message: "Please select tax option",
                  },
                ]}
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-switch"
                  // size="large"
                  options={chargeOptions
                    ?.filter(
                      (option) =>
                        option.chargeTimeType?.toLowerCase() ===
                        "deal activation"
                    )
                    .map((option) => ({
                      value: option.value,
                      label: option.label,
                    }))}
                  placeholder={"Select tax option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col
            span={6}
            style={{
              padding: "0px 8px",
              marginTop: 35,
              display: "flex",
              gap: 10,
            }}
          >
            {" "}
            <Form.Item
              name={"redemptionCharges"}
              style={{ margin: 0, padding: 0 }}
              valuePropName="checked"
            >
              <Switch className="custom-switch" />
            </Form.Item>
            {/* </Col> */}
            {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
              Redemption Charges
            </Text>
          </Col>
          {redemptionCharges && (
            <Col span={6} style={{ padding: "0px 8px", marginTop: 28 }}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="redemptionCharge"
                rules={[
                  {
                    required: true,
                    message: "Please select tax option",
                  },
                ]}
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-input"
                  // size="large"
                  options={chargeOptions
                    ?.filter(
                      (option) =>
                        option.chargeTimeType?.toLowerCase() === "redemption"
                    )
                    .map((option) => ({
                      value: option.value,
                      label: option.label,
                    }))}
                  placeholder={"Select tax option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        {/* <Row>
          <Col
            span={6}
            style={{
              padding: "0px 8px",
              marginTop: 35,
              display: "flex",
              gap: 10,
            }}
          >
            {" "}
            <Form.Item
              name={"transferCharges"}
              style={{ margin: 0, padding: 0 }}
              valuePropName="checked"
            >
              <Switch className="custom-switch" />
            </Form.Item>
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
              Transfer Charges
            </Text>
          </Col>
          {transferCharges && (
            <Col span={6} style={{ padding: "0px 8px", marginTop: 28 }}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="transferCharge"
                rules={[
                  {
                    required: true,
                    message: "Please select tax option",
                  },
                ]}
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-input"
                  // size="large"
                  options={chargeOptions}
                  placeholder={"Select tax option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row> */}
        {/* <Row>
          <Col
            span={6}
            style={{
              padding: "0px 8px",
              marginTop: 35,
              display: "flex",
              gap: 10,
            }}
          >
            {" "}
            <Form.Item
              name={"allowBrokerage"}
              style={{ margin: 0, padding: 0 }}
              valuePropName="checked"
            >
              <Switch className="custom-switch" />
            </Form.Item>
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
              Brokerage/Agent Commission
            </Text>
          </Col>
          {allowBrokerage && (
            <Col span={6} style={{ padding: "0px 8px", marginTop: 28 }}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="commission"
                rules={[
                  {
                    required: true,
                    message: "Please select tax option",
                  },
                ]}
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-input"
                  // size="large"
                  options={chargeOptions}
                  placeholder={"Select tax option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row> */}
      </Form>
    </SectionCard>
  );
}

export default TaxAndCharges;
